export var checkInbox_lbl_checkSpamTryAgain = {
    key: 'sign_up::checkInbox_lbl_checkSpamTryAgain',
    fallback: "Can't find it? Check your spam folder, or\n<link>re-enter your email and try again</link>"
};
export var checkInbox_lbl_sentEmail = {
    key: 'sign_up::checkInbox_lbl_sentEmail',
    fallback: "We sent an email to"
};
export var checkInbox_lbl_verifyEmail = {
    key: 'sign_up::checkInbox_lbl_verifyEmail',
    fallback: "with a link to verify your email address."
};
export var invalidTokenMessage_lbl_invalidSignUpLink = {
    key: 'sign_up::invalidTokenMessage_lbl_invalidSignUpLink',
    fallback: "The signup link appears to be invalid."
};
export var invalidTokenMessage_lbl_login = {
    key: 'sign_up::invalidTokenMessage_lbl_login',
    fallback: "Already have a PayU Enterprise account? Log in"
};
export var invalidTokenMessage_lbl_problemContact = {
    key: 'sign_up::invalidTokenMessage_lbl_problemContact',
    fallback: "If the problem persists, <link>please contact our support desk</link> (email: support@zooz.com)."
};
export var invalidTokenMessage_lbl_signUpAgain = {
    key: 'sign_up::invalidTokenMessage_lbl_signUpAgain',
    fallback: "Please try to signup again."
};
export var main_lbl_login = {
    key: 'sign_up::main_lbl_login',
    fallback: "Already have a PayU Enterprise account? Log in"
};
export var main_title_checkInbox = {
    key: 'sign_up::main_title_checkInbox',
    fallback: "Check your inbox"
};
export var main_title_createPassword = {
    key: 'sign_up::main_title_createPassword',
    fallback: "Create a password"
};
export var main_title_getStarted = {
    key: 'sign_up::main_title_getStarted',
    fallback: "Get started with PayU Enterprise!"
};
export var main_title_invalidSignUpLink = {
    key: 'sign_up::main_title_invalidSignUpLink',
    fallback: "Invalid signup link"
};
export var signUpForm_btn_getStarted = {
    key: 'sign_up::signUpForm_btn_getStarted',
    fallback: "Get Started"
};
export var signUpForm_lbl_companyName = {
    key: 'sign_up::signUpForm_lbl_companyName',
    fallback: "Company name"
};
export var signUpForm_lbl_domain = {
    key: 'sign_up::signUpForm_lbl_domain',
    fallback: "Your company's website"
};
export var verifySignUpForm_btn_signUp = {
    key: 'sign_up::verifySignUpForm_btn_signUp',
    fallback: "Sign Up"
};
export var verifySignUpForm_lbl_confirmPassword = {
    key: 'sign_up::verifySignUpForm_lbl_confirmPassword',
    fallback: "Confirm password"
};
